import questionnaire from './questionnaire'
import orders from './orders'
import wishlist from './wishlist'
import waitlist from './waitlist'
import viewedProducts from './viewedProducts'
import promo from './promo'
import workshop from './workshop'
import communications from './communications'

export default {
  modules: {
    questionnaire,
    orders,
    wishlist,
    waitlist,
    viewedProducts,
    promo,
    workshop,
    communications
  }
}
